import { noop } from '@tanstack/react-query';
import { useWorkspace } from '@/features/workspaces/helpers';
import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useNoDocumentsToast } from '@/features/documents/helpers';
import { workspaceQuery } from '@/features/workspaces/queries';
import { entityDocumentsQuery } from '@/features/documents/queries';
import { trackRecentWorkspace } from '@/features/workspaces/utils';
import { Main, MainPending } from '@/ui/components/main';
import { VersionHistoryPanel } from '@/features/workspaces/components/version-history-panel';

export const Route = createFileRoute('/_authed/project/$projectId/workspaces/$workspaceId/_layout')(
  {
    component: RouteComponent,
    loader: async ({ context, params, preload }) => {
      const { id, name, type, projectId } = await context.queryClient.query({
        ...workspaceQuery(params.workspaceId),
        staleTime: 'static',
      });
      context.queryClient.query(entityDocumentsQuery(params.workspaceId, type)).catch(noop);
      if (!preload)
        trackRecentWorkspace({ id, name, type, projectId }, context.auth.user.organizationId);
    },
    pendingComponent: MainPending,
  },
);

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const navigate = useNavigate();
  const workspace = useWorkspace();

  useNoDocumentsToast({
    resourceId: workspaceId,
    documentType: workspace.type,
    onGoToFiles: () =>
      navigate({
        to: '/project/$projectId/workspaces/$workspaceId/files',
        params: { projectId, workspaceId },
      }),
  });

  return (
    <Main className="flex flex-row">
      <div className="grow flex flex-col min-w-0 min-h-0">
        <Outlet />
      </div>
      <VersionHistoryPanel />
    </Main>
  );
}
